import { Tracking } from 'web-core/src/tracking';

export function bindPageViewTracking() {
  return () => {
    Tracking.trackPageView();
  };
}
